import { render, staticRenderFns } from "./CourseCertificate.vue?vue&type=template&id=389d9e63"
import script from "./CourseCertificate.vue?vue&type=script&lang=js"
export * from "./CourseCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports